import React from 'react'

export default function Details() {
  return (
    <>
      <h1>Details</h1>
      <p><span className='tag-grey bold'>.details</span> class creates a stylized container to summarize the important details of an entity </p>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="details"&gt;<br/>
          &lt;div class="details-left"&gt;<br/>
              &lt;p&gt;
                  hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promotes
              &lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;div class="details-right"&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <div className="details">
          <div className="details-left">
          <p>
              hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote 
          </p>
          </div>
          <div className="details-right">
          <p>hhh</p>
          <p>hhh</p>
          </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="details details-dark"&gt;<br/>
          &lt;img src="image.png" class="details-img"/&gt;<br/>
          &lt;div class="details-left"&gt;<br/>
              &lt;p class="details-title"&gt;Title&lt;/p&gt;<br/>
              &lt;p&gt;
                  hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promotes
              &lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;div class="details-right"&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <div className="details details-dark">
          <img alt="exampleimg" src="https://images.unsplash.com/photo-1604147706283-d7119b5b822c?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGxhaW4lMjB3aGl0ZXxlbnwwfHwwfHx8MA%3D%3D" className="details-img"/>
          <div className="details-left">
          <p className="details-title">Title</p>
          <p>
              hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote 
          </p>
          </div>
          <div className="details-right">
          <p>hhh</p>
          <p>hhh</p>
          </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="details details-dgrey"&gt;<br/>
          &lt;img src="image.png" class="details-img"/&gt;<br/>
          &lt;div class="details-left"&gt;<br/>
              &lt;p class="details-title"&gt;Title&lt;/p&gt;<br/>
              &lt;p&gt;
                  hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promotes
              &lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;div class="details-right"&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <div className="details details-dgrey">
          <img alt="detailsImg" src="https://images.unsplash.com/photo-1604147706283-d7119b5b822c?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGxhaW4lMjB3aGl0ZXxlbnwwfHwwfHx8MA%3D%3D" className="details-img"/>
          <div className="details-left">
          <p className="details-title">Title</p>
          <p>
              hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote 
          </p>
          </div>
          <div className="details-right">
          <p>hhh</p>
          <p>hhh</p>
          </div>
        </div>
      </div>

      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="details details-grey"&gt;<br/>
          &lt;img src="image.png" class="details-img"/&gt;<br/>
          &lt;div class="details-left"&gt;<br/>
              &lt;p class="details-title"&gt;Title&lt;/p&gt;<br/>
              &lt;p&gt;
                  hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promotes
              &lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;div class="details-right"&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
              &lt;p&gt;hhh&lt;/p&gt;<br/>
          &lt;/div&gt;<br/>
          &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve flex-align-xy'>
        <div className="details details-grey">
          <img alt="detailsImg" src="https://images.unsplash.com/photo-1604147706283-d7119b5b822c?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGxhaW4lMjB3aGl0ZXxlbnwwfHwwfHx8MA%3D%3D" className="details-img"/>
          <div className="details-left">
          <p className="details-title">Title</p>
          <p>
              hhhths is som o text A Student-Centered Group-Based Learning System which facilitate structuring and various forms of communication amongst small-sized student-formed group learning in order to promote 
          </p>
          </div>
          <div className="details-right">
          <p>hhh</p>
          <p>hhh</p>
          </div>
        </div>
      </div>
    </>
  )
}
